export default {
  created() {
    const { s } = this.$route.query;
    this.shopId = s;
    this.$store.dispatch("vip/getShop", { shop_id: this.shopId }).then((data = {}) => {
      const { shopName = "" } = data;
      document.title = shopName ? `${shopName}-会员注册` : "会员注册";
    });
  }
};
